import DeskReservation from './DeskReservation';
import Route from './route';

export default {
  RenderProp: DeskReservation,
  mainRoute: Route,
};
